const cta = document.querySelector( '.main__wrap > .cta:last-child' );
const halfWidthCta = document.querySelector( '.main__wrap > .half-width-cta:last-child' );
if ( cta ) {
	cta.classList.add( 'cta-last' );
}
if ( halfWidthCta ) {
	halfWidthCta.classList.add( 'cta-last' );
}
// check if cta content is present and hide if no content. This is used to remove empty cta blocks added by default to post/event/resource pages
const ctaContent = document.querySelector( '.main__wrap .cta .cta__content > .cta-heading' );    

if(ctaContent && ctaContent.innerHTML == "") {

    const ctaBlock = document.querySelector('.cta');
	ctaBlock.remove()
}